[
  {
    "id": "spirit_scene_first_death",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_first_death_1",
        "text": "You died. I want to say that plainly, because you are going to be tempted to describe it to yourself some other way — a bad dream, a fall, a fever — and every hour you spend on that softening is an hour you do not spend on the thing that killed you. You died, and the world put itself back, and here you are."
      },
      {
        "id": "spirit_scene_first_death_2",
        "text": "What you are feeling now is not grief, whatever it resembles. Grief is for things that are over. Nothing here is over. The people you watched die are downstairs arguing about firewood, and they will keep being downstairs arguing about firewood every single time you begin again, and the only thing that will ever change about that morning is what you do with it.",
        "grantsKnowledge": ["spirit_explained_death"]
      }
    ]
  },
  {
    "id": "spirit_scene_dawnmere_held",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_dawnmere_held_1",
        "text": "The village is standing. I have watched a great many mornings and I want you to understand how rare it is that one of them goes differently — not because the world is cruel, particularly, but because it is heavy, and it takes an enormous amount of effort applied at exactly the right place to move it even slightly."
      },
      {
        "id": "spirit_scene_dawnmere_held_2",
        "text": "You found that place. Notice what it actually was: not courage, not the sword, not being told the future. It was evidence, carried to somebody with the authority to act, early enough that acting was still possible. Remember that shape. You are going to need it in larger rooms than this one.",
        "grantsKnowledge": ["spirit_taught_evidence_matters"]
      }
    ]
  },
  {
    "id": "spirit_scene_first_faction",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_first_faction_1",
        "text": "A court has looked at you and decided you are a person rather than a petitioner. That is a smaller thing than it feels like and a larger thing than it looks like, and you should be careful not to confuse it with friendship. They have agreed to keep hearing you. That is all they have agreed."
      },
      {
        "id": "spirit_scene_first_faction_2",
        "text": "And it will not survive your death. Whatever you build with them dissolves the moment the loop turns over, down to the last handshake, and you will walk back into that hall a stranger again. I am sorry. I am telling you now rather than letting you learn it the expensive way: build the *knowledge* of how to win them, not the winning itself. The knowledge is the only thing that comes with you."
      }
    ]
  },
  {
    "id": "spirit_scene_first_mastery",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_first_mastery_1",
        "text": "You have mastered something. Not learned — mastered, which is a different animal entirely, and which took days you will never get back out of a budget you cannot see the bottom of. I want to be honest that I flinched a little watching you spend them."
      },
      {
        "id": "spirit_scene_first_mastery_2",
        "text": "But it is the right trade, and it is very nearly the only right trade there is. Everything else you accumulate — coin, soldiers, the goodwill of kings — is written in water and gone by morning. This is not. Whatever else this loop takes back from you at the end, it cannot reach into your hands and take out what they now know how to do.",
        "grantsKnowledge": ["spirit_confirmed_mastery_persists"]
      }
    ]
  },
  {
    "id": "spirit_scene_first_subjection",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_first_subjection_1",
        "text": "A realm has put itself under your hand. I notice that you did not ask me whether you should, and I notice that I did not offer, and I would like both of us to sit with that for a moment rather than hurrying past it."
      },
      {
        "id": "spirit_scene_first_subjection_2",
        "text": "It is necessary. Seven realms fighting seven separate wars on seven separate schedules is precisely how the sun goes out, and somebody has to hold the whole shape of it in one head. But necessary is not the same as clean, and a man who forgets the difference between them tends to end up somewhere he did not intend to be standing. Keep noticing it. That is all I ask."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_orcs",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_orcs_1",
        "text": "You have met the orcs properly now, which means you have met the first lie of this war. They are not the enemy. They are the pressure wave in front of it — pushed out of the wastes by something further back that they are considerably more afraid of than they are of you, and arriving at your fences with the desperation of people who have nowhere else to go."
      },
      {
        "id": "spirit_scene_enemy_orcs_2",
        "text": "That does not make them safe and it does not make Dawnmere any less burned. It does mean that killing every one of them accomplishes nothing permanent, because the thing that is pushing them will simply push the next lot. Somewhere out in the Blacktooth there is a tear in the world doing the pushing. Deal with the cause, or spend five hundred days dealing with the symptom."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_dragons",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_dragons_1",
        "text": "A dragon. I felt you decide, somewhere around the second pass, that this was not a thing that could be fought — and you were right, in the sense you meant it. Steel skids off. Fire is a joke told to a thing made of it. Courage is entirely beside the point."
      },
      {
        "id": "spirit_scene_enemy_dragons_2",
        "text": "But it can be answered. Not by you, and not by anything you can carry — by volume. Enough shafts in the air at once that the arithmetic stops favouring the scale, which is a thing the High Elves worked out several ages ago and have been quietly practising ever since. The lesson is not about dragons. It is that every one of these horrors has a specific answer, and finding out what it is beforehand is worth more than any amount of bravery on the day."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_trolls",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_trolls_1",
        "text": "You will have watched the wounds close. There is a particular kind of despair in that, in doing everything correctly and watching it undone in front of you, and I suspect it landed harder than the danger did."
      },
      {
        "id": "spirit_scene_enemy_trolls_2",
        "text": "Sit with the shape of it, because it is your shape too. Something that undoes damage as fast as it is done cannot be beaten by doing more damage. It has to be met with the one thing it cannot undo. For the trolls of the Mire that is fire, and the Sevenfold Tower keeps people who carry it. For the loop you are standing in — well. We will come to that."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_dark_elves",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_dark_elves_1",
        "text": "They did not fight you. I want to be precise about that, because your soldiers will tell the story as a battle and it was not one — it was an accounting, done in the dark, by people who had already decided the outcome before anyone drew."
      },
      {
        "id": "spirit_scene_enemy_dark_elves_2",
        "text": "An army that cannot see is not an army, it is a crowd with weapons. The Wood Elves of Greenveil can find them; almost nobody else can. Bring pathfinders or do not go. And notice, please, that you now know somebody else who works exactly this way, who chooses his ground days in advance and is never where you expect. That is not a coincidence of temperament. It is a method, and methods can be answered."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_undead",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_undead_1",
        "text": "The dead are not the enemy either. They are furniture. Something drove an anchor into old ground and the dead stand up because the anchor is what is standing them up, and they will keep standing up for exactly as long as it remains, no matter how thoroughly you put them back down."
      },
      {
        "id": "spirit_scene_enemy_undead_2",
        "text": "Unmake the stone and the whole field lies down at once. That is ritual work — the Tower's orders, or the Wardens of the lake who can hold the ground while the work is done. You are being taught the same lesson from a different angle every time you fight: find what is actually holding the thing upright, and stop hitting the part that is merely visible."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_giants",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_giants_1",
        "text": "Giants have never had to learn caution, which is the most useful thing about them. They do not scout, they do not feint, and they have never in their long slow history had cause to wonder whether a thing they intended to step on might have prepared for it."
      },
      {
        "id": "spirit_scene_enemy_giants_2",
        "text": "The dwarves of Stonehall have been preparing for it since before the kingdom had a name. They know precisely which joint gives and precisely how long they have before the ground arrives. There is no substitute for that and there is no clever improvisation that replaces it — this is simply a war fought by specialists, and your entire job is to have the right specialist standing in the right valley on the right morning."
      }
    ]
  },
  {
    "id": "spirit_scene_enemy_demons",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_enemy_demons_1",
        "text": "You have looked into the tear. I would rather you had not had to, and I am aware that saying so is useless, and I am saying it anyway."
      },
      {
        "id": "spirit_scene_enemy_demons_2",
        "text": "What comes through is not the problem. What comes through is a consequence, and it will keep being a consequence for exactly as long as the opening remains open, and it widens on its own if nobody attends to it. This is the Necromancer's method in miniature — he does not build armies, he opens holes and lets the world supply the army for him. Close the hole. Everything on this side of it becomes finite the moment you do."
      }
    ]
  },
  {
    "id": "spirit_scene_anti_player_met",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_anti_player_met_1",
        "text": "Stop. Before you file that away as a robbery, or a grudge, or somebody's cousin with a grievance — think about what he actually said to you. He used your name. He referred to a thing you did, and you had not yet done it in front of anyone who lived."
      },
      {
        "id": "spirit_scene_anti_player_met_2",
        "text": "There is one other person in this world for whom this morning is not the first morning. I have known that for longer than I have known you and I could not tell you until you had seen it with your own eyes, which is a constraint I resent more than I can usefully explain. He remembers. All of it, the same way you do, and considerably more of it than you do."
      },
      {
        "id": "spirit_scene_anti_player_met_3",
        "text": "So understand what you are actually up against. Not a stronger swordsman — a man with your advantage and a much longer run at it. Every road you take twice, he will eventually be sitting on. Every teacher you rely on, he will eventually think to remove first. He does not have to beat you. He only has to keep you from becoming the person who could win.",
        "grantsKnowledge": ["anti_player_remembers_loops"]
      }
    ]
  },
  {
    "id": "spirit_scene_anti_player_identity",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_anti_player_identity_1",
        "text": "Aldric Vane. I have not been able to say that name to you, and you should know that the silence was not discretion — I could not. Whatever measures out what I am permitted to tell you appears to price a name at 'discovered by the person who needs it', and not one word cheaper."
      },
      {
        "id": "spirit_scene_anti_player_identity_2",
        "text": "He was from Dawnmere, four houses along from where you woke this morning. He was chosen the way you were chosen, and he was given the same impossible errand and the same insufficient explanation by something that may well have been me, though I have no memory of it and I have stopped finding that reassuring."
      },
      {
        "id": "spirit_scene_anti_player_identity_3",
        "text": "And he ran at it for a very long time. Longer than you have. Long enough to try everything you are currently proud of having thought of, and to bury everyone he was doing it for, more than once, in the same order each time. What you are fighting is not a villain. It is what is left of somebody who did your job for a hundred years and could not make it come out.",
        "grantsKnowledge": ["anti_player_was_a_chosen_one"]
      }
    ]
  },
  {
    "id": "spirit_scene_anti_player_defeated",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_anti_player_defeated_1",
        "text": "You won. He is dead on the ground in front of you and I need you to look at it properly, because tomorrow morning he will be in Dawnmere, four houses along, with every single thing he knows about you intact — including exactly how you did this."
      },
      {
        "id": "spirit_scene_anti_player_defeated_2",
        "text": "You cannot kill him. Not because he is protected, but because the two of you are the same kind of thing, and the loop that will not let go of you will not let go of him either. Every sword you put through him is a lesson you are giving away for free."
      },
      {
        "id": "spirit_scene_anti_player_defeated_3",
        "text": "Which leaves the harder road, and I think you have already worked out what it is. He is not doing this because he is wicked. He is doing it because he has concluded, on a century of evidence, that the loop closes when the one who holds it open stops holding it — and he has decided that is you. Find out who he was. Find out what he actually wants. Then go and take the conclusion away from him, which will require being right and being believed, and neither of those is a thing you can do with a blade.",
        "grantsKnowledge": ["anti_player_cannot_be_killed"]
      }
    ]
  },
  {
    "id": "spirit_scene_anti_player_severed",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_anti_player_severed_1",
        "text": "He stood down. I have been watching this world for a length of time I have no honest way of expressing to you, and I did not think that was among the available outcomes."
      },
      {
        "id": "spirit_scene_anti_player_severed_2",
        "text": "Notice what actually did it. Not the duels — you had already won those, several times, and they bought you nothing but a better-informed opponent. It was the records: a hundred years of a man being wrong about one specific thing, and somebody finally arriving who could prove it and had the standing to be listened to while doing so. He did not surrender. He was corrected."
      },
      {
        "id": "spirit_scene_anti_player_severed_3",
        "text": "He will not trouble you again in any loop. What he does with the rest of it is his own, and I find I am glad it is a question he gets to have. Now — the thing you both actually came for is still out there, and it has not been corrected by anybody."
      }
    ]
  },
  {
    "id": "spirit_scene_ebon_citadel",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_ebon_citadel_1",
        "text": "So this is the place. I find I have very little to say that is useful, which is not an experience I have often, and I notice that the limit on my tongue seems to fall away entirely the closer you stand to it — as though whatever set that limit is no longer confident it will matter."
      },
      {
        "id": "spirit_scene_ebon_citadel_2",
        "text": "Everything the ritual needs is already here. It does not require his attention any more than a fire requires yours once it has taken the roof. When the last of it seats, the sun does not go dark all at once — it thins, the way a lamp thins, and everything under it that needs light works out what has happened at roughly the same moment."
      },
      {
        "id": "spirit_scene_ebon_citadel_3",
        "text": "You have until the five hundred and twelfth day, and the citadel does not care how many loops it took you to reach its door. Go in with everything, or do not go in."
      }
    ]
  },
  {
    "id": "spirit_scene_ritual_omen",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_ritual_omen_1",
        "text": "You felt that. The noon sun, gone thin and cold for a moment, and then not quite all the way back. That is not weather. That is the ritual taking its first real bite, and it will take another, and another, on a schedule as fixed as the events you have learned to intercept."
      },
      {
        "id": "spirit_scene_ritual_omen_2",
        "text": "I tell you this because I know how a loop tempts you to think. You imagine the deadline as a wall you will crash into on the last day, far off, abstract. It is not a wall. It is a tide, already coming in, and the light going out of the sky a little more each week is the water reaching your ankles. Do not measure your loops against Day 512. Measure them against how dark it is when you stand at the citadel door.",
        "grantsKnowledge": ["spirit_explained_ritual_is_gradual"]
      }
    ]
  },
  {
    "id": "spirit_scene_citadel_breached",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_scene_citadel_breached_1",
        "text": "You are inside. I did not think I would ever say that to anyone. In every loop I can remember, the citadel was a door that could be reached and never opened — and the thing that opened it was not a sword or an army but a man you chose not to kill, who gave you the one thing he had that no blade could take from him."
      },
      {
        "id": "spirit_scene_citadel_breached_2",
        "text": "Understand what stands between you and the end of all of this now. Not a wall. Not a gate. A person, and five hundred days of his work, and every servant he armed to buy that work time. Everything you have made of yourself is for the next hour. Go down, and be quick, and do not fight the dead — reach the hand that raises them."
      }
    ]
  }
]
